import { combineReducers } from 'redux';
import csProcessPayment from './csProcessPayment';
import paymentToken from './paymentToken';
import tokenizationRequests from './tokenizationRequests';
import createSessionReducer from './createSessionReducer';

const appReducer = combineReducers({
    csProcessPayment,
    paymentToken,
    tokenizationRequests,
    createSessionReducer,
});

export default (state, action) => {
    return appReducer(state, action);
};
